import type { EnhancedAnsweringPrice } from './AppointmentDeskContext';

const CENTS = 100;

export const pricingTierCalculator = (
  enhancedPrices: EnhancedAnsweringPrice[],
  listingsCount: number,
): number | string => {
  if (!listingsCount) return '0';
  // Error handling wasn't specified from the Product Team.
  if (!enhancedPrices?.length) return 'Err';
  const priceAmount =
    enhancedPrices.find(
      price =>
        price.start <= listingsCount &&
        (!price.end || price.end >= listingsCount),
    )?.amount || 0;

  return priceAmount / CENTS;
};

export const getFinalPriceWithTier = (
  enhancedPrices: EnhancedAnsweringPrice[],
  listingsCount: number,
): number => {
  const priceAmount = pricingTierCalculator(enhancedPrices, listingsCount);
  // Error handling wasn't specified from the Product Team.
  if (typeof priceAmount === 'string') return 0;

  return priceAmount * listingsCount;
};
